/**
 * English papers store two sections as two "main" question numbers, so the catalogue
 * used to show "2Q". Show sections for English (or when the count is clearly sections).
 */
export function catalogueCountLabel({ subjects = [], questionsCount = 0, sectionsCount = 0 } = {}) {
  const isEnglish = (subjects || []).some((name) =>
    String(name).toLowerCase().includes("english")
  );
  const questions = Number(questionsCount) || 0;
  const sections = Number(sectionsCount) || 0;
  if (isEnglish || (sections >= 2 && questions > 0 && questions <= sections)) {
    const n = sections >= 2 ? sections : questions;
    if (!n) return null;
    return { value: n, unit: n === 1 ? "section" : "sections" };
  }
  if (!questions) return null;
  return { value: questions, unit: "Q" };
}
